import React, { Component } from 'react';
import COLORS from 'constants/colors';
import { Text, FlexView, Row, Col } from '@cuemath/comps';
import styled from 'styled-components';

import { BLOCK_TYPE_OPTIONS } from 'constants/block-options';
import { ReactComponent as CloseIcon } from 'img/cancel-icon.svg';

import ChapterBlock from './chapter-block';
import EmptyBlock from './empty-block';

const BackgroundWrapper = styled.div`
  padding-top: 20px;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  padding-bottom: 48px;
`;

const SectionRect = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background-color: ${COLORS.HEART_LIGHT};
`;

const VerticalLine = styled.div`
  width: 2px;
  margin-left: 5px;
  height: ${({ height = 12 }) => `${height}px`};
  background-color: ${COLORS.HEART_LIGHT};
`;

const SectionTitle = styled(Text)`
  font-size: 20px;
  letter-spacing: 2px;
  line-height: 23px;
`;

const SectionWrapper = styled(FlexView)`
  margin-bottom: 30px;
`;

const EmptyBlockWrapper = styled.div`
  width: 780px;
  padding: 30px 0;
  border-radius: 4px;
  margin-top: ${({ gapAtTop }) => (gapAtTop ? '20px' : '0')};
  background-color: ${({ handleCursor }) =>
    handleCursor ? `${COLORS.WHITE}` : `${COLORS.IRON_LIGHT}`};
  cursor: ${({ handleCursor }) => (handleCursor ? 'default' : 'pointer')};
  box-shadow: ${({ handleCursor }) =>
    !handleCursor && `0 5px 15px 0 ${COLORS.POLICE_BLUE_LIGHT}`};
  border: ${({ handleCursor }) =>
    !handleCursor && `1px solid ${COLORS.RAISIN_BLACK_LIGHT}`};
  position: relative;

  :hover {
    background-color: ${({ handleCursor }) => !handleCursor && `${COLORS.IRON}`};
  }
`;

const EmptyBlockCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 23px;
  height: 23px;
`;

const EmptyBlockTitle = styled(Text)`
  font-size: 18px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
`;

class Chapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmptyBlock: false,
    };

    this.emptyBlockReference = React.createRef();
  }

  toggleShowEmptyBlock = blockMem => {
    this.emptyBlockReference.current = blockMem;

    if (this.emptyBlockReference.current === blockMem) {
      this.setState({
        showEmptyBlock: true,
      });
    } else {
      this.setState({
        showEmptyBlock: false,
      });
    }
  };

  handleCloseEmptyBlock = e => {
    e.stopPropagation();

    this.emptyBlockReference.current = null;
    this.setState({
      showEmptyBlock: false,
    });
  };

  render() {
    const {
      masteryCardData,
      dependencyDataList,
      nodeDataList,
      linkedDataList,
    } = this.props;
    const { showEmptyBlock } = this.state;

    let goalCount = 0;

    return (
      <BackgroundWrapper>
        <Wrapper>
          {masteryCardData &&
            masteryCardData.length > 0 &&
            masteryCardData.map((item, index) => (
              <SectionWrapper key={item.section_code}>
                <Row>
                  <Col gutter={18}>
                    <FlexView>
                      <SectionRect />
                      <VerticalLine height={18} />
                    </FlexView>
                  </Col>
                  <SectionTitle weight="semibold" color={COLORS.ABBEY}>
                    {item.section_code}
                  </SectionTitle>
                </Row>
                {item.block.length > 0 &&
                  item.block.map((element, index) => {
                    const { block_type: blockType } = element || {};
                    let goalIndex = 0;

                    if (blockType === BLOCK_TYPE_OPTIONS.GOAL) {
                      goalCount += 1;
                      goalIndex = goalCount;
                    }

                    return (
                      <ChapterBlock
                        key={element.id}
                        {...element}
                        goalIndex={goalIndex}
                        blockType={blockType}
                        dependencyDataList={dependencyDataList}
                        linkedDataList={linkedDataList}
                        nodeDataList={nodeDataList}
                        isLastBlock={index === item.block.length - 1}
                      />
                    );
                  })}
                <EmptyBlockWrapper
                  gapAtTop={item.block.length > 0}
                  handleCursor={
                    this.emptyBlockReference.current === `${item.section_code}_${index}`
                  }
                  onClick={() =>
                    this.toggleShowEmptyBlock(`${item.section_code}_${index}`)
                  }
                >
                  {this.emptyBlockReference.current ===
                  `${item.section_code}_${index}` ? (
                    <EmptyBlockCloseIcon onClick={e => this.handleCloseEmptyBlock(e)} />
                  ) : (
                    <EmptyBlockTitle>Empty Block List</EmptyBlockTitle>
                  )}
                  {showEmptyBlock &&
                    this.emptyBlockReference.current ===
                      `${item.section_code}_${index}` &&
                    item.emptyBlock &&
                    item.emptyBlock.length > 0 &&
                    item.emptyBlock.map((element, index) => {
                      const { block_type: blockType } = element || {};
                      let goalIndex = 0;

                      if (blockType === BLOCK_TYPE_OPTIONS.GOAL) {
                        goalCount += 1;
                        goalIndex = goalCount;
                      }
                      return (
                        <EmptyBlock
                          key={element.id}
                          emptyMasteryBlock={element}
                          goalIndex={goalIndex}
                          blockType={blockType}
                          dependencyDataList={dependencyDataList}
                          linkedDataList={linkedDataList}
                          nodeDataList={nodeDataList}
                          isLastBlock={index === item.emptyBlock.length - 1}
                        />
                      );
                    })}
                </EmptyBlockWrapper>
              </SectionWrapper>
            ))}
        </Wrapper>
      </BackgroundWrapper>
    );
  }
}

export default Chapter;
